import { Mail, Phone, MapPin, Instagram, Youtube, Twitter, Linkedin } from "lucide-react";
import Logo from "@/components/Logo";

const NAV_LINKS = [
  { label: "Explore", href: "#explore" },
  { label: "Shows", href: "#shows" },
  { label: "Submit Content", href: "#submit-content" },
  { label: "Contact Us", href: "#contact" },
];

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/viewna_o?stkn=eWM2eDJrYzFmZmRi" },
  { icon: Youtube, label: "YouTube", href: "#explore" },
  { icon: Twitter, label: "Twitter", href: "#explore" },
  { icon: Linkedin, label: "LinkedIn", href: "#explore" },
];

export default function Footer({ onOpenAdmin }) {
  return (
    <footer data-testid="site-footer" className="relative border-t border-gold-500/15 bg-black/70">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="flex flex-col items-center gap-7 text-center">
          <Logo size="lg" />
          <p
            className="font-display text-[11px] font-semibold uppercase tracking-[0.6em] text-gold-400"
            data-testid="footer-tagline"
          >
            Entertainment Beyond Boundaries
          </p>

          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3" data-testid="footer-nav">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-[11px] uppercase tracking-[0.24em] text-stone-400 transition-colors hover:text-gold-400"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            {SOCIALS.map(({ icon: Icon, label, href }) => (
              <a
                key={label}
                href={href}
                {...(href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                aria-label={`VIEWNA on ${label}`}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-stone-800 text-stone-400 transition-all duration-300 hover:border-gold-500/60 hover:text-gold-400"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>

          <div className="flex flex-wrap justify-center gap-x-7 gap-y-2 text-[13px] text-stone-500">
            <span className="inline-flex items-center gap-2"><Mail className="h-3.5 w-3.5 text-gold-500" /> info@viewna.co.in</span>
            <span className="inline-flex items-center gap-2"><Phone className="h-3.5 w-3.5 text-gold-500" /> +91 99208 29818</span>
            <span className="inline-flex items-center gap-2"><MapPin className="h-3.5 w-3.5 text-gold-500" /> Mumbai, Maharashtra</span>
          </div>

          <p className="max-w-xl text-[13px] leading-relaxed text-stone-500" data-testid="footer-corporate-entity">
            VIEWNA is a brand owned and operated by{" "}
            <span className="text-stone-300">Viewna Pvt Ltd</span>
          </p>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-stone-800/80 pt-8 sm:flex-row">
          <p className="text-xs tracking-wide text-stone-500" data-testid="footer-copyright">
            © 2026 VIEWNA. All rights reserved.
          </p>
          <button
            data-testid="admin-sign-in-link"
            onClick={onOpenAdmin}
            className="text-[11px] font-bold uppercase tracking-[0.3em] text-gold-500/80 transition-all duration-300 hover:text-gold-300 hover:drop-shadow-[0_0_12px_rgba(212,175,55,0.5)]"
          >
            Admin Sign In
          </button>
        </div>
      </div>
    </footer>
  );
}
